import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const buildQueryString = (params) => {
  const {
    sort,
    sortOrder,
    page,
    pageSize,
    ship,
    minSailDateObj,
    maxSailDateObj,
    nights,
    category,
    priceAdv,
    percAdv,
    region,
    selectedPorts,
    sellingAgent,
  } = params;

  // const soldOutParam = excludeSoldOut ? "&excludeSoldOut=true" : "";
  const agentParam = sellingAgent
    ? `&sellingAgent=${encodeURIComponent(sellingAgent)}`
    : "";
  const portsParam = selectedPorts
    ? `&selectedPorts=${encodeURIComponent(selectedPorts)}`
    : "";

  // return `?sort=${sort}&sortOrder=${sortOrder}&page=${page}&pageSize=${pageSize}&cruiseLine=${cruiseLine}&ship=${ship}&excludeSoldOut=${soldOutParam}&minSailDateObj=${minSailDateObj}&maxSailDateObj=${maxSailDateObj}&nights=${nights}&category=${category}&priceAdv=${priceAdv}&percAdv=${percAdv}&region=${region}${portsParam}${agentParam}`; // Add portsParam here
  return `?sort=${sort}&sortOrder=${sortOrder}&page=${page}&pageSize=${pageSize}&cruiseLine=Virgin%20Voyages&ship=${ship}&minSailDateObj=${minSailDateObj}&maxSailDateObj=${maxSailDateObj}&nights=${nights}&category=${category}&priceAdv=${priceAdv}&percAdv=${percAdv}&region=${region}${portsParam}${agentParam}`; // Add portsParam here
};

const fetchCruises = createAsyncThunk(
  "cruises/fetch",
  async ({ selectedPorts, ...params }, { getState }) => {
    const state = getState();

    const queryString = buildQueryString({
      ...params,
      sellingAgent: "kimberly@revolutiontravel.ca",
      selectedPorts: selectedPorts,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
        "systemUserToken": "systemtoken5f9a1d7a4d1b93abc000",
        "systemUserId": "systemid5f9a1d7a4d1e6a7abc000",
        // "systemUserToken": process.env.REACT_APP_SYSTEM_USER_TOKEN,
        // "systemUserId": process.env.REACT_APP_SYSTEM_USER_ID,
      },
    };

    try {
      const response = await axios.get(
        `https://www.cruisecompare.ca:6010/cruises${queryString}`,
        config
      );

      // Update agentId in all cruise URLs
      if (response.data && response.data.cruises) {
        response.data.cruises = response.data.cruises.map(cruise => {
          if (cruise.Url) {
            // Replace agentId parameter with new value
            cruise.Url = cruise.Url.replace(/agentId=\d+/, 'agentId=117747');
          }
          return cruise;
        });
      }

      return response.data;
    } catch (error) {
      throw error;
    }
  }
);

export { fetchCruises };
